<div class="web" *ngIf="config.mode=='web'">
  <div class="multi-image-chart-wrapper" [style.width.px]="config.width"
    role="group" tabindex="0"
    [attr.aria-label]="(config.title ? config.title + ' chart' : 'chart') + '. Press Enter to navigate into chart'"
    (keydown)="onContainerKeydown($event)">
    <div class="multi-image-title" *ngFor="let item of items; let itemIndex = index">
      <div class="content" [style.width.px]="item.width" [style.min-height.px]="80">
        <div class="data" *ngIf="itemIndex%2==0" [style.padding-left.px]="item.width/2">
          <div [style.overflow]="'visible'">
            <div [style.width.px]="200">{{item.title}}</div>
          </div>
          <div><strong [style.font-size]="'20px'" [style.color]="item.color">{{item.label}}</strong></div>
          <div class="multi-image-line" [style.background]="item.color"></div>
        </div>
      </div>
    </div>
    <div class="multi-image-chart" #picturesRow [style.width.px]="config.width">
      <div *ngFor="let item of items; let i = index" class="multi-image-item"
           [style.width.px]="item.width"
           [style.min-height.px]="200"
           [style.background-image]="'url('+item.image+')'"
           [style.background-size]="'cover'"
           [attr.tabindex]="i === focusedIndex ? 0 : -1"
           role="group"
           [attr.aria-label]="item.title + (item.value ? ', ' + item.value : '')"
           (focus)="focusedIndex = i"
           (keydown)="onItemKeydown($event, i)">
      </div>
    </div>
    <div class="row">
      <div class="multi-image-title" *ngFor="let item of items; let itemIndex = index" [style.margin-top.px]="-18">
        <div class="content" [style.width.px]="item.width" [style.min-height.px]="80">
          <div class="data" *ngIf="itemIndex%2==1" [style.padding-left.px]="item.width/2">
            <div class="multi-image-line" [style.background]="item.color"></div>
            <div><strong [style.font-size]="'20px'" [style.color]="item.color">{{item.label}}</strong></div>
            <div [style.overflow]="'visible'">
              <div [style.width.px]="200">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mobile" *ngIf="config.mode!='web'">
  <div class="multi-image-chart-wrapper" [style.width.px]="config.width" [style.height.px]="config.height + 130">
    <div class="row text-center">
      <div style="float: left" [style.width.px]="(config.width - 70)/2 - 25" [style.height.px]="config.height">
        <div *ngFor="let item of items; let itemIndex = index" [style.height.px]="item.height/2">
          <div class="multi-image-title"
               [style.visibility]="itemIndex%2==1?'visible':'hidden'"
               [style.margin-top.px]="item.height/2">
            <div class="multi-image-line"
                 [style.margin-left.px]="(config.width - 70)/2 - 15"
                 [style.background]="item.color"></div>
            <div [style.margin-left.px]="15"
                 [style.margin-top.px]="-15"
                 [style.padding-right.px]="15">{{item.title}}
            </div>
            <div [style.margin-left.px]="(config.width - 70)/2 - 30" [style.margin-top.px]="-5">
              <div><strong [style.font-size]="'20px'" [style.color]="item.color">{{item.label}}</strong></div>
            </div>
          </div>
        </div>
      </div>
      <div style="float: left;border-radius: 50px;overflow: hidden;">
        <div *ngFor="let item of items" class="multi-image-item"
             [style.height.px]="item.height"
             [style.min-width.px]="100"
             [style.background-image]="'url('+item.image+')'"
             [style.background-size]="'cover'">
        </div>
      </div>
      <div style="float: left" [style.width.px]="(config.width - 70)/2 - 25" [style.height.px]="config.height">
        <div *ngFor="let item of items; let itemIndex = index" [style.height.px]="item.height/2">
          <div class="multi-image-title" [style.visibility]="itemIndex%2==0?'visible':'hidden'">
            <div class="multi-image-line"
                 [style.margin-top.px]="item.height/2"
                 [style.margin-left.px]="-60"
                 [style.background]="item.color"></div>
            <div [style.margin-left.px]="20" [style.margin-top.px]="-15">{{item.title}}</div>
            <div [style.margin-left.px]="20" [style.margin-top.px]="-5">
              <div><strong [style.font-size]="'20px'" [style.color]="item.color">{{item.label}}</strong></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
